module.exports = __webpack_public_path__ + "static/media/error-cat.ff068b2d.png";